import React from 'react'
import { observer } from 'mobx-react'
import { TelegramSettingContainer } from '@views/Popup/TelegramSetting/index.style'

interface TelegramSettingProps {
  popupImageUrl: string
}

const TelegramSetting = ({ popupImageUrl }: TelegramSettingProps): React.ReactElement => {
  return (
    <TelegramSettingContainer>
      {popupImageUrl && <img src={popupImageUrl} alt="텔레그램 연동 완료"/>}
    </TelegramSettingContainer>
  )
}

export default observer(TelegramSetting)
